import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import useStore from "../../lib/store";

const KeyboardHint = () => {
  const keyboardNav = useStore((s) => s.keyboardNav);
  const dismissed = useStore((s) => s.dismissedKeyboardHint);

  return (
    <AnimatePresence>
      <motion.div
        className="keyboard-hint"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 8 }}
        transition={{ duration: 0.2 }}
      >
        <span>
          {keyboardNav
            ? "Press"
            : "Try out keymaps for a keyboard-friendly version of the website"}
        </span>
        {keyboardNav && (
          <span>
            <kbd>space</kbd> for shortcuts
          </span>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default KeyboardHint;
